<template>
  <div class="player-status" ref="componentRef">
    <Avatar :level="player.level" />
    <div class="right-container">
      <div class="has-s-heading-size">{{ player.name }}</div>
      <div class="has-m-body-size">{{ player.description }}</div>
      <ProgressBar class="progress-bar" :prevStars="player.prevStars" :stars="player.stars" :nextStars="player.nextStars" />
    </div>
    <Dialog v-if="levelUpVisible">
      <div :class="['level-up-heading', 'has-m-heading-size']">
        Onneksi olkoon!<br/>
        Ansaitsit uuden tittelin:
      </div>
      <div :class="['level-up-title', 'has-xl-heading-size']">
        {{player.description}}
      </div>
      <button
        class="level-up-button"
        @click="levelUpVisible = false"
      >
        OK
      </button>
    </Dialog>
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'

import useZoom from '@/composition/useZoom'
import Avatar from './Avatar.vue'
import Dialog from './Dialog.vue'
import ProgressBar from './ProgressBar.vue'
import {getItem, setItem} from '@/utils/local-storage'
import {getPlayerInfo} from '@/utils/player'

export default {
  components: {
    ProgressBar,
    Avatar,
    Dialog,
  },
  setup () {
    const levelUpVisible = ref()
    const player = getPlayerInfo()
    const lastSeenLevel = getItem('last_seen_level')
    const currentLevel = player.level

    if (
      currentLevel > 1 &&
      (!lastSeenLevel || currentLevel > lastSeenLevel)
    ) {
      setItem('last_seen_level', currentLevel)
      levelUpVisible.value = currentLevel
    }

    const componentRef = ref()

    useZoom(componentRef, 2.2)

    return {
      player,
      componentRef,
      levelUpVisible,
    }
  },
}
</script>

<style scoped lang="scss">
.player-status {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 24px 20px 24px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: variables.$color-light-purple;
  border-radius: 20px 20px 0 0;
  box-shadow: 4px 4px 4px #00000014;

  @include media.query($from: 1024) {
    left: 28px;
    right: auto;
    bottom: 20px;
    border-radius: 20px;
  }

  .right-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    color: variables.$color-white;
    min-width: 240px;

    .progress-bar {
      margin-top: 6px;
    }
  }
}

.level-up-heading {
  margin-bottom: 32px;
}

.level-up-title {
  margin-bottom: 32px;
  text-transform: uppercase;
}

.level-up-button {
  max-width: 100%;
  min-width: 350px;
}
</style>
